export default __webpack_public_path__ + "static/media/note-alt-w.e8d8b002.svg";